import PropTypes from "prop-types";
import { Container, Typography, Box } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCube, faCoffee } from "@fortawesome/free-solid-svg-icons";


export default function ControlPageTitle({ pageTitle, className, pageTitleIcon }) {
    if (!pageTitle) {
        pageTitle = "No Title Provided";
    };

    
    return (
        <Container sx={{ p: 1 }} className={className} maxWidth="lg">
            <Box sx={{ width: '100%', height: '100%', verticalAlign: 'middle' }}>
                <Typography variant="h1" sx={{ verticalAlign: 'middle' }} >
                    <FontAwesomeIcon icon={pageTitleIcon ? pageTitleIcon : faCoffee} style={{ paddingLeft: '10px', paddingRight: '10px' }} />
                    {pageTitle}
                </Typography>
            </Box>
        </Container>
    );
};
ControlPageTitle.propTypes = {
    pageTitle: PropTypes.string,
    className: PropTypes.string,
    pageTitleIcon: PropTypes.object, // FontAwesomeIcon object
};